export const pages = {
  home: {
    title: "pages.home.title",
    subtitle: null,
    description: "pages.home.description",
    image: "home_banner.jpg",
  },
  booking: {
    title: "pages.booking.title",
    subtitle: null,
    description: "pages.booking.description",
    image: "room_banner.jpg",
  },
  story: {
    title: "pages.story.title",
    subtitle: null,
    description: "pages.story.description",
    image: "dolasab_beach.jpg",
  },
  activities: {
    title: "pages.activities.title",
    subtitle: "pages.activities.subtitle",
    description: null,
    image: "activities_banner.jpg",
  },
  photos: {
    title: "pages.photos.title",
    subtitle: null,
    description: "pages.photos.description",
    image: "photos_banner.jpg",
  },
  contact: {
    title: "pages.contact.title",
    subtitle: "pages.contact.subtitle",
    description: "pages.contact.description",
    image: "contact_banner.jpg",
  },
  success: {
    title: "pages.success.title",
    subtitle: null,
    description: null,
    image: "activities_banner.jpg",
  },
  // privacy: {
  //   title: "Confidentialité",
  //   subtitle: null,
  //   description: null,
  //   image: "rules_banner.jpg",
  // },
  // terms: {
  //   title: "Conditions d'utilisation",
  //   subtitle: null,
  //   description: null,
  //   image: "rules_banner.jpg",
  // },
  // politic: {
  //   title: "Politique",
  //   subtitle: null,
  //   description: null,
  //   image: "rules_banner.jpg",
  // },
  error: {
    title: "pages.error.title",
    subtitle: null,
    description: "pages.error.description",
    image: "home_banner.jpg",
  },
};
